$.fn.stickyHeader = function() {
	var $me    = $(this),
		height = $me.next().offset().top;

	$(window).on('scroll', function() {
		var scrollTop = $(this).scrollTop();

		if(scrollTop >= height) {
			$me.addClass('sticky');
		} else {
			$me.removeClass('sticky');
		}
	});	
};

$('.site-header').stickyHeader();

if(breakpts.value !== 'large') {
	$('.site-header .has-dropdown > span').on('click', function(e) {
		$(this).closest('li').toggleClass('showmenu');
	});

}
